import { Component, Input } from "@angular/core";
import { FundingInstructionsOrderBy } from "@merchant_api/models/funding-instructions-order-by";

@Component({
    selector: "app-funding-table-cell-content",
    templateUrl: "./funding-table-cell-content.component.html",
    styleUrls: ["./funding-table-cell-content.component.less"],
    standalone: false
})
export class FundingTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;

    FundingInstructionsOrderBy = FundingInstructionsOrderBy;

}
